import { useCallback, useState } from "react";

import getUserUseCase from "@app/features/User/domain/use-cases/getUserUseCase";
import editUserUseCase from "@app/features/User/domain/use-cases/editUserUseCase";
import IUserModel from "@app/features/User/domain/models/IUserModel";

import { IUserRepository } from "@app/features/User/data/userRepository";

import handleApplicationError from "@app/handles/handleApiError";
import showNotification from "@app/components/molecules/Toast";

export type TEditUserViewModel = {
  id: number;
  userStatuClasse: string;
  roleId: number;
};

const useEditUserViewModel = (repository: IUserRepository) => {
  const [isLoading, setLoading] = useState(false);
  const [user, setUser] = useState<IUserModel>();

  const editUser = useCallback(
    async (data: TEditUserViewModel) => {
      try {
        setLoading(true);

        await editUserUseCase(
          {
            editUser: repository.editUser,
          },
          data
        );
        setLoading(false);
        showNotification("Dados alterados com sucesso", "SUCCESS");
      } catch (error) {
        setLoading(false);
        handleApplicationError.handleError(error);
      }
    },
    [repository.editUser]
  );

  const getUser = useCallback(
    async (userId: number) => {
      try {
        setLoading(true);

        const result = await getUserUseCase(
          {
            getUser: repository.getUser,
          },
          userId
        );
        setUser(result);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleApplicationError.handleError(error);
      }
    },
    [repository.getUser]
  );

  return { user, isLoading, getUser, editUser };
};

export { useEditUserViewModel };
